/** @jsxImportSource theme-ui */

import React from 'react';
import { colors, sizing } from '../../tokens';
import { AllCaroteneColors, TextAlign } from '../utils/types';

export interface BodyProps extends Omit<React.HTMLAttributes<HTMLParagraphElement>, 'color' | 'css'> {
    variant?: 'alt' | 'base';
    size?: keyof typeof sizing.font | 'string';
    children: React.ReactNode | React.ReactNodeArray;
    color?: AllCaroteneColors;
    align?: TextAlign;
}

export default function Body({ size, variant, children, color, align, ...otherProps }: BodyProps): JSX.Element {
    return (
        <p
            {...otherProps}
            sx={{
                variant: `body.default-${variant}`,
                fontSize: size,
                color: color,
                textAlign: align,
            }}
        >
            {children}
        </p>
    );
}

Body.defaultProps = {
    size: 'medium',
    variant: 'base',
    color: colors.base.black,
};
